// Single source of truth for the signature-template language codes/labels —
// mirrors backend LANGUAGE_CHOICES (backend/signatures/models.py). Shared by
// SignatureForm.jsx (language-variant tabs), Signatures.jsx (list badge) and
// UserDetailPopup.jsx — keep in sync by hand if the backend list ever grows
// past tr/en.
export const LANGUAGE_CHOICES = [
  ['tr', 'Türkçe'],
  ['en', 'English'],
  ['de', 'Deutsch'],
  ['ar', 'العربية'],
  ['ru', 'Русский'],
  ['fr', 'Français'],
  ['ro', 'Română'],
];

export const LANGUAGE_LABELS = Object.fromEntries(LANGUAGE_CHOICES);

// Stable display order (backend returns whatever order it happens to build,
// e.g. Object.keys on a dict) — used anywhere multiple language codes need
// to render as one joined string, like Signatures.jsx's "TR/EN" list badge.
export const LANGUAGE_ORDER = LANGUAGE_CHOICES.map(([code]) => code);
